import { styled } from "styled-system/jsx"

export const Tag = styled("span", {
  base: {
    alignItems: "center",
    display: "inline-flex",
    rounded: true,
    // If palettes have explicit bg/fg values, use them. Otherwise, fall
    // back to the default with auto-contrasted color.
    background: "secondary",
    color: "text.muted",
    gap: "xs",
    paddingX: "sm",
  },
  variants: {
    module: {
      previousInteractions: {
        background: "modules.previousInteractions",
        color: "text.onDark",
      },
      handover: {
        background: "modules.handover",
        color: "text.onDark",
      },
      voiceBotHandover: {
        background: "modules.handover",
        color: "text.onDark",
      },
      askCopilot: {
        background: "modules.askCopilot",
        color: "text.onDark",
      },
      liveSummary: {
        background: "modules.liveSummary",
        color: "text",
      },
    },
  },
})
